var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddMembersHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "var(--icon-bg, currentColor)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21682_15026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.8125C12 8.08661 10.6009 6.6875 8.875 6.6875C7.14911 6.6875 5.75 8.08661 5.75 9.8125C5.75 11.5384 7.14911 12.9375 8.875 12.9375C10.6009 12.9375 12 11.5384 12 9.8125Z",
    stroke: "var(--icon-fg, var(--color-text-primary))",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 17.3125C13.25 14.8963 11.2912 12.9375 8.875 12.9375C6.45876 12.9375 4.5 14.8963 4.5 17.3125",
    stroke: "var(--icon-fg, var(--color-text-primary))",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8.5V13.5M19.5 11H14.5",
    stroke: "var(--icon-fg, var(--color-text-primary))",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21682_15026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 13,
    fill: "white",
    transform: "translate(4 5.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMembersHeader);
export default __webpack_public_path__ + "static/media/add_members_header.c239176237d01bc560f46083099d2760.svg";
export { ForwardRef as ReactComponent };